import styled from 'styled-components';

export const Wrapper = styled.div`
  && {
    width: 100%;
    .inline {
      display: inline-block;
    }
    .header1 {
      height: 85px;
      .icon1 {
        margin-right: 10px;
        margin-bottom: 25px;
        font-size: 20px;
      }
      .anticon-right {
        margin-top: 3px;
        font-size: 15px;
      }
      .ant-steps {
        padding-left: 1%;
        width: 915px;
        .ant-steps-item-icon {
          border-color: white;
          background: rgba(196, 196, 196, 1);
        }
      }
      .ant-steps-item-container .ant-steps-item-content:nth-child(2) div {
        background-color: red;
      }
      .ant-steps-small.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:first-child {
        padding-left: 0;
        margin-left: 18px;
        margin-right: 15px;
      }
      .ant-steps-small.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:nth-child(2) {
        margin-right: 15px;
      }
      .ant-steps-small.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:nth-child(3) {
        margin-right: 15px;
      }
      .ant-steps-small.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:nth-child(4) {
        margin-right: 15px;
      }
      .ant-steps-small.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:nth-child(5) {
        margin-right: 20px;
      }
      .ant-steps-navigation .ant-steps-item-container {
        padding-bottom: 8px;
      }
      .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
        color: white;
      }
      .wrap-step {
        margin-left: -17px;
        width: 100%;
        background: white;
        border-radius: 23.5px;
      }
      .ant-steps-navigation .ant-steps-item::after {
        left: 100%;
        width: 9px;
        height: 9px;
        margin-top: -12px;
        margin-left: 2px;
      }
      .ant-steps-item-process {
        .ant-steps-item-icon {
          background: #c1e18d;
          border-color: white;
        }
        font-family: Hiragino Kaku Gothic Pro;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 21px;
      }
      .ant-steps-item-wait {
        font-family: Hiragino Kaku Gothic Pro;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 21px;
      }
      .ant-steps-item::before {
        display: none;
      }
    }
    .header2 {
      height: 68px;
      background-color: rgba(236, 255, 184, 1);
      padding-right: 65px;
      padding-left: 65px;
      display: flex;
      align-items: center;
      .anticon-plus {
        font-size: 25px;
      }
    }
    .btnBack {
      background-color: #ff8a00;
      color: white;
      border: none;
      border-radius: 0;
      bottom: -12px;
    }
    .ant-tooltip {
      color: rgba(235, 164, 80, 1);
    }

    div[role='tooltip'] {
      color: rgba(235, 164, 80, 1);
    }
  }
`;
